export default "__VITE_ASSET__C9dvN9yx__"